// The completed mention inline element (e.g. an inserted "@Mary Smith" chip).
export const AGENT_MENTION = 'agent-mention';

// The leaf mark applied to the in-progress "@search" text the agent is typing. We read the marked
// text to drive the search and use its rendered span to anchor the mention menu.
export const MARK_AGENT_MENTION_SEARCH = 'agent-mention-search';

// The character that starts an agent mention search.
export const AGENT_MENTION_ACTIVATION_CHARACTER = '@';
